import React, { useState, useEffect, useRef } from 'react'
import * as ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import * as wjCore from '@mescius/wijmo'
import * as wjXlsx from '@mescius/wijmo.xlsx'
import * as wjMultiRow from '@mescius/wijmo.react.grid.multirow'
import * as wjCell from '@mescius/wijmo.grid.cellmaker'
import { KeyAction, DataMap } from '@mescius/wijmo.grid'
// import { FlexGridPdfConverter, ScaleMode } from '@mescius/wijmo.grid.pdf'
import '@mescius/wijmo.cultures/wijmo.culture.ja'
import moment from 'moment'

import { makeStyles } from '@material-ui/core/styles'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import Encoding from 'encoding-japanese'

import customContextMenu from '../../wijmo/customContextMenu'
import colElements from '../../wijmo/columnElements'
import editableFlexGridInitialize from '../../wijmo/editableFlexGridInitialize'
import FlexGridFileImport from '../input/FlexGridFileImport'
import { getNearestPrice, multiplyDecimals } from '../../utility'
import BootstrapAlert from '../element/BootstrapAlert'

// MaterialUIのスタイル定義
const useStyles = makeStyles({
  tableContainer: {
    display: 'inline-block',
    maxWidth: 500,
    minWidth: 400
  },
  tableHead: {
    backgroundColor: 'silver'
  },
  tableFoot: {
    backgroundColor: 'gold'
  },
  cellEmphasized: {
    fontWeight: 'bold'
  }
})

function RoyalityTable (props) {
  const styles = useStyles()

  return (
    <TableContainer className={styles.tableContainer} component={Paper}>
      <Table size="small" aria-label="請求額">
        <TableHead className={styles.tableHead}>
          <TableRow>
            <TableCell></TableCell>
            <TableCell align="right">金額</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              最低責任使用料
            </TableCell>
            <TableCell align="right">￥{props.sumRoyality.toLocaleString()}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              追加額
            </TableCell>
            <TableCell align="right">￥{props.sumAddRoyality.toLocaleString()}</TableCell>
          </TableRow>
          <TableRow className={styles.tableFoot}>
            <TableCell component="th" scope="row">
              請求額
            </TableCell>
            <TableCell className={styles.cellEmphasized} align="right">￥{(props.sumRoyality + props.sumAddRoyality).toLocaleString()}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}

RoyalityTable.propTypes = {
  sumRoyality: PropTypes.number,
  sumAddRoyality: PropTypes.number
}

function getLayoutDefs (itemsCV, isDisabled, stampNoticeOptions, stampId, isShopro) {
  const deleteButtonCol = {
    cssClassAll: 'wj-style-green',
    width: 80,
    align: 'center',
    cellTemplate: wjCell.CellMaker.makeLink({
      text: '削除',
      href: 'javascript:void(0);',
      click: (e, cell) => { itemsCV.remove(cell.item) },
      attributes: {
        class: 'btn ol-theme-primary py-0'
      }
    })
  }
  const ldTwoLines = [
    {
      colspan: isDisabled ? 2 : 3,
      cells: [
        { ...colElements.id, rowspan: 2, align: 'right' },
        { ...colElements.name, rowspan: 2, isReadOnly: false, cssClassAll: 'wj-style-basic-input', width: 250 },
        isDisabled ? null : { ...colElements.name_length }
      ].filter((col) => col)
    },
    {
      colspan: 3,
      cells: [
        { ...colElements.price, isReadOnly: false, cssClassAll: 'wj-style-basic-input' },
        { ...colElements.rate_decimal, isReadOnly: false, cssClassAll: 'wj-style-basic-input' },
        { ...colElements.amount, isReadOnly: false, cssClassAll: 'wj-style-basic-input' },
        { ...colElements.royality, colspan: 2 },
        colElements.royality_total
      ]
    },
    {
      colspan: 1,
      cells: [
        { ...colElements.use_amount, isReadOnly: false, cssClassAll: 'wj-style-green-input' },
        { ...colElements.stamp_amount }
      ]
    },
    {
      colspan: 2,
      cells: [
        colElements.expect_remain_amount,
        colElements.expect_add_amount,
        { ...colElements.add_royality, colspan: 2 }
      ]
    },
    {
      colspan: 4,
      cells: [
        (stampId === '000' || stampId === '999')
          ? { ...colElements.stamp_notice, isReadOnly: false, cssClassAll: 'wj-style-green-input', dataMap: new DataMap([stampId === '000' ? '印刷' : '免除']) }
          : { ...colElements.stamp_notice, isReadOnly: false, cssClassAll: 'wj-style-green-input', dataMap: new DataMap(stampNoticeOptions) },
        { ...colElements.ratio_stamp },
        { width: 15, cssClassAll: 'wj-style-green', isReadOnly: true, cellTemplate: (ctx) => '/' },
        { ...colElements.ratio_item, isReadOnly: false, cssClassAll: 'wj-style-green-input' },
        isShopro ? { ...colElements.stamp_name, colspan: 4 } : { cssClassAll: 'wj-style-green', colspan: 4 }
      ]
    },
    {
      colspan: isDisabled ? 1 : 2,
      cells: [
        { ...colElements.comment, isReadOnly: false, cssClassAll: 'wj-style-green-input', rowspan: 2 },
        isDisabled ? null : { ...colElements.comment_length }
      ].filter((col) => col)
    },
    isDisabled
      ? null
      : {
          colspan: 1,
          cells: [
            { ...deleteButtonCol, rowspan: 2 }
          ]
        }
  ].filter((col) => col)
  const layoutDefs = new wjCore.CollectionView([
    {
      name: '2行表示',
      def: ldTwoLines,
      frozenColumns: isDisabled ? 4 : 5
    }
  ])
  return layoutDefs
}

// useEffectで変更前の値を参照するための仕組み
function usePrevious (value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

//
export default function NewContractItemGrid (props) {
  const stampId = props.stampId.toString()

  const isDisabled = props.isDisabled
  const [itemsCV, setItemsCV] = useState(null)
  const [layoutDefs, setLayoutDefs] = useState(null)
  const [currentLayout, setCurrentLayout] = useState(null)
  const [sumRoyality, setSumRoyality] = useState(0)
  const [sumAddRoyality, setSumAddRoyality] = useState(0)
  const [commonRate, setCommonRate] = useState(0.0)
  const [rateUpdateTargetItems, setRateUpdateTargetItems] = useState(null)
  const prevCommonRate = usePrevious(commonRate)
  const itemsDiffMap = useRef(new Map())
  // 要注意項目を判定する関数 commonRateというstateを参照するため、useEffectで変更を検知する度にrefに再設定する
  const getIsWarningFieldRef = useRef((item, column) => false)

  const diffExist = props.itemsDiff.add.length > 0 || props.itemsDiff.change.length > 0 || props.itemsDiff.delete.length > 0
  const calclateRoyality = !isDisabled

  // 入力項目の名前と初期値
  const inputsDefault = {
    id: 0,
    serial_no: null,
    name: '',
    price: 0,
    rate: commonRate * 100,
    amount: 0,
    stamp_notice: stampId === '000' ? '印刷' : (stampId === '999' ? '免除' : '通常'),
    use_amount: 0,
    ratio_stamp: 1,
    ratio_item: 1,
    comment: ''
  }

  function itemsToJson (items) {
    const inputFields = {
      id: { type: 'number', decimalPlace: 0 },
      serial_no: { type: 'number', decimalPlace: 0 },
      name: { type: 'string' },
      price: { type: 'number', decimalPlace: 0 },
      rate: { type: 'number', decimalPlace: 2 },
      royality: { type: 'number', decimalPlace: 2 },
      amount: { type: 'number', decimalPlace: 0 },
      stamp_notice: { type: 'string' },
      use_amount: { type: 'number', decimalPlace: 0 },
      ratio_stamp: { type: 'number', decimalPlace: 0 },
      ratio_item: { type: 'number', decimalPlace: 0 },
      comment: { type: 'string' }
    }

    const inputs = items.map((item) => {
      const input = {}
      Object.keys(inputFields).forEach((field) => {
        const format = inputFields[field]
        if (format.type === 'number') {
          const pow = Math.pow(10, format.decimalPlace)
          input[field] = Math.round(item[field] * pow) / pow
        } else {
          input[field] = item[field]
        }
      })
      return input
    })

    return JSON.stringify(inputs)
  }

  const addItem = () => {
    const item = {}

    item.rate_decimal = commonRate
    Object.keys(inputsDefault).forEach((field) => {
      if (field === 'rate' || field === 'ratio_stamp') return
      item[field] = inputsDefault[field]
    })

    itemsCV.sourceCollection.push(item)
    itemsCV.collectionChanged.raise(itemsCV)
    itemsCV.sortDescriptions.collectionChanged.raise(itemsCV.sortDescriptions)
  }

  // インポート/エクスポート時のテーブルを定義
  const tableFormat = [
    { field: 'name', text: '商品名', type: 'string', isEditable: true, maxLength: colElements.name.maxLength },
    { field: 'price', text: '税抜小売価格', type: 'number', isEditable: true, maxLength: colElements.price.maxLength },
    { field: 'rate_decimal', text: '料率', type: 'number', isEditable: true, maxLength: colElements.rate_decimal.maxLength - 2, isRate: true },
    { field: 'royality', text: '使用料単価', type: 'number', isEditable: false },
    { field: 'amount', text: '数量', type: 'number', isEditable: true, maxLength: colElements.amount.maxLength },
    { field: 'royality_total', text: '使用料', type: 'number', isEditable: false },
    { field: 'use_amount', text: '製造数量', type: 'number', isEditable: true, maxLength: colElements.use_amount.maxLength },
    { field: 'stamp_amount', text: '証紙枚数', type: 'number', isEditable: false },
    { field: 'stamp_notice', text: '証紙特記', type: 'string', isEditable: true },
    { field: 'ratio_stamp', text: '掛率証紙', type: 'number', isEditable: false },
    { field: 'ratio_item', text: '掛率数量', type: 'number', isEditable: true },
    { field: 'comment', text: '備考', type: 'string', isEditable: true, maxLength: colElements.comment.maxLength }
  ]

  useEffect(() => {
    // 最初だけ実行
    const items = props.items || []

    items.forEach((item) => {
      item.rate_decimal = item.rate / 100
      delete item.rate
      delete item.ratio_stamp
      if ('add_royality_prod' in item) {
        item.add_royality_prod = Number(item.add_royality_prod)
      }

      // 入力モードかつroyalityがデータ上にある場合、priceの小数点以下を調整して整合性が取れるようにする
      if (calclateRoyality && 'royality' in item) {
        item.price = getNearestPrice(item.price, item.rate_decimal, item.royality)
        delete item.royality
      } else {
        item.royality = Number(item.royality)
      }

      if (stampId === '000') {
        item.stamp_notice = '印刷'
      } else if (stampId === '999') {
        item.stamp_notice = '免除'
      }
    })

    props.itemsDiff.change.forEach((diff) => {
      itemsDiffMap.current.set(diff.serial_no, diff.item)
    })
    props.itemsDiff.add.forEach((diff) => {
      itemsDiffMap.current.set(diff.serial_no, diff.item)
    })

    const calculatedFields = {
      rate: (obj) => obj.rate_decimal * 100,
      royality_total: (obj) => (isDisabled && obj.royality_prod) ? obj.royality_prod : Math.round(multiplyDecimals(obj.royality, obj.amount, 2, 0)),
      expect_remain_amount: (obj) => Math.max(obj.amount - obj.use_amount, 0),
      expect_add_amount: (obj) => Math.max(obj.use_amount - obj.amount, 0),
      add_royality: (obj) => (isDisabled && 'add_royality_prod' in obj) ? obj.add_royality_prod : Math.round(multiplyDecimals(obj.royality, obj.expect_add_amount, 2, 0)),
      ratio_stamp: (obj) => obj.stamp_notice === '免除' || obj.stamp_notice === '印刷' ? 0 : 1,
      stamp_amount: (obj) => Math.ceil((obj.amount - obj.expect_remain_amount) * obj.ratio_stamp / obj.ratio_item) + Math.ceil(obj.expect_add_amount * obj.ratio_stamp / obj.ratio_item),
      name_length: (obj) => Encoding.convert(Encoding.stringToCode(obj.name ?? ''), { to: 'SJIS', from: 'UNICODE' }).length / 2,
      comment_length: (obj) => obj.comment?.length ?? 0
    }
    if (calclateRoyality) {
      calculatedFields.royality = (obj) => Math.round(obj.price * obj.rate_decimal * 100) / 100
    }
    const getError = (item, propName) => {
      if (['price'].includes(propName)) {
        if (item.price < 0.5) {
          return '税抜小売価格には1円以上を指定してください。'
        }
      }
      if (['price', 'royality'].includes(propName)) {
        // testRoyality: 見た目で（＝価格が四捨五入された値で）計算された使用料
        const testRoyality = Math.round(multiplyDecimals(Math.round(item.price), item.rate_decimal * 100, 0, 2)) / 100
        if (Math.abs(item.royality - testRoyality) > 0.001) {
          return `使用料単価が整数での計算値（￥${testRoyality.toFixed(2)}）と異なる可能性があります。このままでも申請可能ですがよくご確認ください。`
        }
      }
      if (props.isConfirm && ['amount'].includes(propName)) {
        if (item.amount === 0) {
          return '最低責任数量が入力されておりません。お間違いないかご確認ください。'
        }
      }
      return null
    }
    const _itemsCV = new wjCore.CollectionView(items, {
      canAddNew: !isDisabled,
      canRemove: !isDisabled,
      calculatedFields: calculatedFields,
      getError: getError
    })
    _itemsCV.collectionChanged.addHandler((cv, e) => {
      setSumRoyality(_itemsCV.getAggregate(wjCore.Aggregate.Sum, colElements.royality_total.binding))
      setSumAddRoyality(_itemsCV.getAggregate(wjCore.Aggregate.Sum, colElements.add_royality.binding))

      // アイテム情報のJSONを隠し要素に記録（フォーム送信時に参照する）
      if (!isDisabled) {
        $('#items-json').val(itemsToJson(_itemsCV.items))
      }
    })
    _itemsCV.onCollectionChanged()

    setItemsCV(_itemsCV)
    const _layoutDefs = getLayoutDefs(_itemsCV, isDisabled, props.stampNoticeOptions, stampId, props.isShopro)
    _layoutDefs.currentChanged.addHandler(() => {
      setCurrentLayout(_layoutDefs.currentItem)
    })
    _layoutDefs.onCurrentChanged()
    setLayoutDefs(_layoutDefs)

    // 料率のinputの変更を取得してcommonRateに反映する
    const rateInput = $('input[name="rate"]')
    if (rateInput) {
      rateInput.change((e) => {
        setCommonRate(parseFloat(e.target.value) / 100)
      })
      rateInput.trigger('change')
    } else {
      console.error('name="rate"であるinput要素が存在しません。')
    }
  }, [])

  useEffect(() => {
    // 要注意項目の判定関数を再設定（stateのcommonRateを参照するため）
    getIsWarningFieldRef.current = (item, column) => {
      if (column.binding === 'rate_decimal') {
        return item.rate_decimal !== commonRate
      } else if (column.binding === 'stamp_notice') {
        return item.stamp_notice !== '通常'
      } else if (column.binding === 'ratio_item') {
        return item.ratio_item !== 1
      } else if (column.binding === 'ratio_stamp') {
        return item.ratio_stamp !== 1
      } else {
        return false
      }
    }
    // commonRateが変更されたとき、デフォルト料率が指定されていたアイテムの料率を変更する
    if (itemsCV && !isDisabled) {
      if (itemsCV.items.length === 0 && prevCommonRate === 0 && commonRate > 0) {
        addItem()
      } else {
        const targetItems = itemsCV.items.filter((item) => Math.abs(prevCommonRate - item.rate_decimal) < 0.00001)
        if (targetItems.length > 0) {
          setRateUpdateTargetItems(targetItems)
        }
        itemsCV.refresh()
      }
    }
  }, [commonRate])

  function rateUpdate () {
    if (rateUpdateTargetItems) {
      rateUpdateTargetItems.forEach((item) => {
        item.rate_decimal = commonRate
        // 料率変更時に小数の小売価格をリセットする
        // ※使用料単価を調整したアイテムを編集した際、小売価格がそのままだと計算が合わないように見えるため
        if (item.price % 1 !== 0) {
          item.price = 0
        }
      })
      itemsCV.refresh()

      setRateUpdateTargetItems(null)
    }
  }

  function getIsEditable (item, column) {
    if (column.binding === 'ratio_item') {
      return item.stamp_notice === '代表'
    } else {
      return true
    }
  }

  const gridInit = (grid) => {
    grid.formatItem.addHandler((s, e) => {
      if (e.panel === s.cells) {
        const item = e.getRow().dataItem
        const column = grid.getBindingColumn(e.panel, e.row, e.col)
        // 編集不可の行のスタイル変更
        if (e.cell.className.search(/wj-style-[^b]+-input/g)) {
          if (!getIsEditable(item, column)) {
            wjCore.removeClass(e.cell, 'wj-style-green-input')
            wjCore.addClass(e.cell, 'wj-style-green')
          }
        }
        // 要注意項目のスタイル設定
        if (getIsWarningFieldRef.current(item, column)) {
          wjCore.addClass(e.cell, 'text-danger')
          wjCore.addClass(e.cell, 'font-weight-bold')
        }
        // 申請修正時、変更箇所をマーキング
        const diff = itemsDiffMap.current.get(item.serial_no)
        if (diff) {
          let hasDiff = false
          if (column.binding === 'rate_decimal') {
            hasDiff = 'rate' in diff
          } else if (column.binding === 'use_amount') {
            hasDiff = ('use_amount' in diff || 'add_amount' in diff)
          } else {
            hasDiff = column.binding in diff
          }

          if (hasDiff) {
            wjCore.addClass(e.cell, 'wj-cell-alert')
          }
        }
      }
    })

    grid.beginningEdit.addHandler((s, e) => {
      const item = e.getRow().dataItem
      const column = grid.getBindingColumn(e.panel, e.row, e.col)
      if (!getIsEditable(item, column)) {
        e.cancel = true
      }
    })

    grid.cellEditEnding.addHandler((s, e) => {
      const column = s.getBindingColumn(e.panel, e.row, e.col)
      if (column.binding === 'name') {
        // タブ文字・改行を削除
        const value = grid.activeEditor.value?.replaceAll(/[\t\r\n]/ig, '')
        if (value !== grid.activeEditor.value) {
          grid.activeEditor.value = value
        }
        const converted = Encoding.convert(Encoding.stringToCode(value), { to: 'SJIS', from: 'UNICODE' })
        if (converted.length > 60) {
          alert('商品名は全角30文字/半角60文字以内で入力してください。')
        }
      } else if (column.binding === 'stamp_notice') {
        if (grid.activeEditor.value !== '代表') {
          // 掛率数量をリセット
          grid.setCellData(e.row, e.col + 3, 1)
        }
      } else if (column.binding === 'rate_decimal') {
        // 料率変更時に小数の小売価格をリセットする
        // ※使用料単価を調整したアイテムを編集した際、小売価格がそのままだと計算が合わないように見えるため
        const beforeRate = e.data * 100
        let afterRate = Number(grid.activeEditor.value.slice(0, -1))
        if (!Number.isNaN(afterRate)) {
          afterRate = Math.round(afterRate * 100) * 0.01
          if (Math.abs(beforeRate - afterRate) >= 0.01) {
            const price = grid.getCellData(e.row, e.col - 1)
            if (price % 1 !== 0) {
              grid.setCellData(e.row, e.col - 1, 0)
            }
          }
        }
      } else if (column.format === 'n0') {
        const casted = Math.floor(grid.activeEditor.value)
        if (grid.activeEditor.value !== casted) {
          grid.activeEditor.value = casted
        }
      }
    })

    // インポート時に入力値をチェックする
    grid.collectionView.sourceCollectionChanged.addHandler((cv) => {
      let changed = false
      const newItem = cv.items.map((item) => {
        // タブ文字・改行を削除
        item.name = item.name.replaceAll(/[\t\r\n]/ig, '')
        const converted = Encoding.convert(Encoding.stringToCode(item.name), { to: 'SJIS', from: 'UNICODE' })
        if (converted.length > 60) {
          alert('商品名は全角30文字/半角60文字以内で入力してください。')
        }
        if (stampId === '000' && item.stamp_notice !== '印刷') {
          item.stamp_notice = '印刷'
          changed = true
        }
        if (stampId === '999' && item.stamp_notice !== '免除') {
          item.stamp_notice = '免除'
          changed = true
        }
        if (!['通常', '印刷', '免除', '代表'].includes(item.stamp_notice)) {
          item.stamp_notice = '通常'
          changed = true
        }
        if (item.stamp_notice !== '代表' && item.ratio_item !== 1) {
          item.ratio_item = 1
          changed = true
        }
        return item
      })
      if (changed) {
        cv.sourceCollection = newItem
        cv.collectionChanged.raise(cv)
      }
    })

    // 内部的に小数を含む列（税抜小売価格）をコピーした際に内部値をコピーするための処理
    grid.copying.addHandler((cv, e) => {
      const range = e.range
      for (let col = range.leftCol; col <= range.rightCol; col++) {
        for (let row = range.topRow; row <= range.bottomRow; row++) {
          const column = grid.getBindingColumn(e.panel, row, col)
          if (column.binding === 'price') {
            column.format_tmp = column.format
            column.format = null
          }
        }
      }
    })
    grid.copied.addHandler((cv, e) => {
      const range = e.range
      for (let col = range.leftCol; col <= range.rightCol; col++) {
        for (let row = range.topRow; row <= range.bottomRow; row++) {
          const column = grid.getBindingColumn(e.panel, row, col)
          if (column.binding === 'price') {
            column.format = column.format_tmp
            column.format_tmp = null
          }
        }
      }
    })

    grid.tableFormat = tableFormat

    customContextMenu(grid)
    editableFlexGridInitialize(grid)

    // 契約書別紙の出力設定
    $('button#get-appendix').each((i, el) => {
      const {
        templateUrl,
        characterTitle,
        periodFrom,
        periodTo,
        contractRoyality,
        appendixFormat,
        appendixName
      } = $(el).data()
      const formats = {
        default: [
          { row: 0, column: 1, text: `【別紙1】${characterTitle}` },
          { row: 0, column: 2, text: periodFrom },
          { row: 0, column: 4, text: periodTo }
        ],
        poke: [
        ],
        dora: [
          { row: 0, column: 1, text: `＜別紙1＞【${characterTitle}】` },
          { row: 0, column: 3, text: `${moment(periodFrom).format('YYYY.MM.DD')}～${moment(periodTo).format('YYYY.MM.DD')}` }
        ]
      }
      const format = formats[appendixFormat]
      $(el).on('click', () => {
        $.ajax({
          url: templateUrl + `?type=${appendixFormat}` + (props.isForGross ? '&is_gross=1' : ''),
          type: 'GET'
        }).done(async (templateData) => {
          const workbook = new wjXlsx.Workbook()
          let sheet = null
          const rowsInSheet = 30
          const items = props.isForGross ? [{}] : grid.collectionView.items.sort((v1, v2) => v1.serial_no - v2.serial_no)
          // itemsを30個ごとに区切ってシートに記録する
          const sheetLength = ((items.length - 1) / rowsInSheet | 0) + 1
          const getSheetName = (i) => `契約書別紙 (${i + 1})`
          for (const i of [...Array(sheetLength).keys()]) {
            await new Promise((resolve) => {
              const itemsBlock = items.slice(i * rowsInSheet, (i + 1) * rowsInSheet)
              // xlsxテンプレートからシートを取り出してworkbookに追加する
              const wb = new wjXlsx.Workbook()
              const templateDataCopy = templateData.content
              wb.loadAsync(templateDataCopy, (wb) => {
                sheet = wb.sheets[0]
                sheet.name = getSheetName(i)
                workbook.sheets.push(sheet)
                if (workbook.styles.length === 0) {
                  wb.styles.forEach((style) => workbook.styles.push(style))
                }
                format.forEach((cell) => {
                  sheet.rows[cell.row].cells[cell.column].value = cell.text
                })
                sheet.rows[0].cells[1].style.wordWrap = false
                itemsBlock.forEach((item, j) => {
                  sheet.rows[2 + j].cells[0].value = i * rowsInSheet + j + 1
                  sheet.rows[2 + j].cells[1].value = props.isForGross ? 'グロス契約' : item.name
                  sheet.rows[2 + j].cells[2].value = props.isForGross ? '-' : Math.round(item.price)
                  sheet.rows[2 + j].cells[3].value = props.isForGross ? '-' : item.royality
                  sheet.rows[2 + j].cells[4].value = props.isForGross ? '-' : item.amount
                  sheet.rows[2 + j].cells[5].value = props.isForGross ? contractRoyality : Math.round(multiplyDecimals(item.royality, item.amount, 2, 0))
                })
                // グロス契約別紙の体裁を整える
                if (props.isForGross) {
                  // 不要な0を非表示にする
                  if (appendixFormat === 'dora') {
                    for (const i of [...Array(rowsInSheet + 1).keys()]) {
                      [2, 3, 4].forEach((k, _) => {
                        sheet.rows[1 + i].cells[k].value = ''
                      })
                    }
                  } else {
                    for (const i of [...Array(rowsInSheet - 1).keys()]) {
                      [2, 3, 4, 5].forEach((k, _) => {
                        sheet.rows[3 + i].cells[k].value = ''
                      })
                    }
                  }
                  // ハイフンの位置を調整
                  [2, 3, 4].forEach((k, _) => {
                    sheet.rows[2].cells[k].style.hAlign = wjXlsx.HAlign.Center
                    sheet.rows[2].cells[k].style.vAlign = wjXlsx.VAlign.Center
                  })
                } else {
                  // 最終シートのみに合計額を表示する
                  if (i === sheetLength - 1) {
                    const sheetFomulae = [...Array(sheetLength).keys()].map((i) => `'${getSheetName(i)}'!F3:F32`)
                    sheet.rows[rowsInSheet + 2].cells[5].formula = `SUM(${sheetFomulae.join(',')})`
                  } else {
                    sheet.rows.splice(rowsInSheet + 2)
                  }
                }
                resolve()
              })
            })
          }
          workbook.saveAsync(
            appendixName
              .replaceAll(' ', '') // 空白を削除
              .replaceAll(/[\\/;:*?"'><|,.]/g, '_') // ファイル名に不適な記号類をアンダーバーに置換
              .replaceAll(/^(_*)/g, '') // 頭にアンダーバーが連続する場合は削除
          )
        }).fail((jqXHR, textStatus, errorThrown) => {
          console.error(errorThrown)
        }).always(() => {
        })
      })
    })
  }

  return (
    layoutDefs && (
      <>
        <div className="d-inline-block w-100 text-center">
          <div className="d-inline-block mw-100">
            {diffExist && (
              <div className="text-left">
                <BootstrapAlert class="danger">
                  <div>赤色で塗られた項目が変更箇所です。</div>
                </BootstrapAlert>
              </div>
            )}
            <div className="w-100 mb-2 text-left">
              {!isDisabled && (
                <>
                  <button className="btn bg-theme-primary" type="button" onClick={addItem}>
                    <AddIcon />
                    <span className='align-middle'>行を追加</span>
                  </button>
                  <FlexGridFileImport
                    tableFormat={tableFormat}
                    collectionView={itemsCV}
                    className='float-right mb-0'
                  />
                </>
              ) }
            </div>
            <wjMultiRow.MultiRow showMarquee={true} itemsSource={itemsCV} layoutDefinition={currentLayout.def}
              isReadOnly={isDisabled} frozenColumns={currentLayout.frozenColumns} keyActionTab={isDisabled ? KeyAction.Cycle : KeyAction.CycleEditable}
              multiRowGroupHeaders={true} initialized={gridInit} validateEdits={false}
              style={{ maxHeight: '500px' }}>
            </wjMultiRow.MultiRow>
            {props.itemsDiff.delete.map((diff) => (
              <div className="text-left" key={diff.serial_no}>
                <BootstrapAlert class="danger">
                  <div>アイテム No.{diff.serial_no}「{diff.item.name}」は削除されました。</div>
                </BootstrapAlert>
              </div>
            ))}
            <div className="w-100 text-right my-2">
              <RoyalityTable
                sumRoyality={sumRoyality}
                sumAddRoyality={sumAddRoyality}
              />
            </div>
          </div>
        </div>
        <Dialog onClose={(e) => setRateUpdateTargetItems(null)} open={!!rateUpdateTargetItems}>
          <DialogTitle>料率変更確認</DialogTitle>
          <DialogContent>
            <DialogContentText>
              基本料率が変更されました。<br />
              変更前の基本料率が設定されているアイテムを、変更後の基本料率に更新しますか？
            </DialogContentText>
            <DialogActions>
              <Button onClick={(e) => setRateUpdateTargetItems(null)}>更新しない</Button>
              <Button color="primary" onClick={rateUpdate}>更新する</Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </>
    )
  )
}

NewContractItemGrid.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  isDisabled: PropTypes.bool,
  isConfirm: PropTypes.bool,
  stampId: PropTypes.string,
  stampNoticeOptions: PropTypes.arrayOf(PropTypes.string),
  itemsDiff: PropTypes.object,
  isShopro: PropTypes.bool,
  isForGross: PropTypes.bool
}

NewContractItemGrid.defaultProps = {
  items: null,
  isDisabled: false,
  isConfirm: false,
  stampId: '',
  stampNoticeOptions: ['通常', '印刷', '免除', '代表'],
  itemsDiff: { add: [], change: [], delete: [] },
  isShopro: false,
  isForGross: false
}

$('.new-contract-item-grid').each((i, elem) => {
  const qel = $(elem)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(<NewContractItemGrid {...props}/>, elem)

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
